import { render } from "./Perfil.vue?vue&type=template&id=6948d100"
const script = {}
script.render = render

export default script